module.exports = __webpack_public_path__ + "static/media/world-map.00a3f37c.png";